module.exports = __webpack_public_path__ + "static/media/food.395ddc82.GIF";